import { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogTeasers } from '@/mocks/articles';
import { mainSiteUrl } from '@/mocks/categories';

const allTeaserImages: Record<number, string> = {
  1: "https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20with%20laptop%20showing%20organized%20spreadsheet%20interface%2C%20warm%20natural%20light%2C%20cream%20beige%20minimalist%20workspace%2C%20editorial%20productivity%20photography%2C%20soft%20shadows&width=800&height=560&seq=teaser-01&orientation=landscape",
  2: "https://readdy.ai/api/search-image?query=Minimalist%20security%20concept%20with%20soft%20cream%20background%2C%20warm%20lighting%2C%20trust%20and%20protection%20symbols%2C%20clean%20editorial%20style%2C%20gentle%20shadows&width=800&height=560&seq=teaser-02&orientation=landscape",
  3: "https://readdy.ai/api/search-image?query=Warm%20learning%20scene%20with%20hands%20typing%20on%20laptop%20next%20to%20notebook%2C%20cream%20workspace%2C%20soft%20natural%20daylight%2C%20minimalist%20tutorial%20concept%2C%20editorial%20photography&width=800&height=560&seq=teaser-03&orientation=landscape",
  4: "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20trendy%20white%20sneakers%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20fashion%20editorial%20aesthetic%2C%20minimalist%20composition&width=800&height=560&seq=teaser-04&orientation=landscape",
  5: "https://readdy.ai/api/search-image?query=Warm%20fashion%20flatlay%20with%20folded%20beige%20hoodie%20and%20cotton%20tshirt%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20streetwear%20aesthetic%2C%20minimalist%20style&width=800&height=560&seq=teaser-05&orientation=landscape",
  6: "https://readdy.ai/api/search-image?query=Minimalist%20comparison%20concept%20with%20warm%20cream%20background%2C%20split%20composition%20showing%20value%20and%20quality%2C%20clean%20editorial%20style%2C%20soft%20natural%20lighting&width=800&height=560&seq=teaser-06&orientation=landscape",
  7: "https://readdy.ai/api/search-image?query=Warm%20product%20collection%20arrangement%20with%20various%20fashion%20items%20on%20cream%20background%2C%20bestseller%20concept%2C%20soft%20golden%20lighting%2C%20editorial%20ecommerce%20aesthetic&width=800&height=560&seq=teaser-07&orientation=landscape",
  8: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20sizing%20guide%20with%20measuring%20tape%20and%20fabric%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20clean%20editorial%20style%2C%20gentle%20shadows&width=800&height=560&seq=teaser-08&orientation=landscape",
  9: "https://readdy.ai/api/search-image?query=Warm%20discovery%20concept%20with%20hidden%20treasure%20aesthetic%20on%20cream%20background%2C%20soft%20golden%20light%2C%20curiosity%20and%20exploration%20theme%2C%20editorial%20minimalist%20photography&width=800&height=560&seq=teaser-09&orientation=landscape"
};

export default function BlogGrid() {
  const [visibleCount, setVisibleCount] = useState(6);

  const showMore = () => {
    setVisibleCount(blogTeasers.length);
  };

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.15em] mb-3">Blog</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.12]">
            Ultime guide
            <br />
            <span className="font-normal italic">Itaobuy Spreadsheet</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogTeasers.slice(0, visibleCount).map((teaser) => (
            <Link
              key={teaser.id}
              to={`/articolo/${teaser.slug}`}
              className="group block rounded-xl bg-background-100/60 overflow-hidden transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={allTeaserImages[teaser.id]}
                  alt={teaser.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="px-5 py-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-semibold text-primary-600 uppercase tracking-wide">
                    {teaser.category}
                  </span>
                  <span className="text-xs text-foreground-400">{teaser.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-300 mb-2 leading-snug">
                  {teaser.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {teaser.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-sm font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Leggi di più
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {visibleCount < blogTeasers.length && (
          <div className="mt-8 text-center">
            <button
              onClick={showMore}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-foreground-200/60 text-sm font-semibold text-foreground-700 whitespace-nowrap cursor-pointer hover:bg-foreground-50 transition-all duration-300"
            >
              Vedi tutti gli articoli
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}